// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo_logo__11VnT","logo__logo":"logo_logo__logo__1O3cO"};